import { Component, inject, NgZone, OnDestroy, OnInit } from "@angular/core";
import { StorageService, MainService } from "@tae/services";
import { DataStorage } from "@tae/interfaces";
import { ENV_CONFIG } from "@tae/tokens";
import { GoPayCommonsService } from "../../../services/go-pay-commons.service";
import { Router } from "@angular/router";
import {
  PageViewInferface,
  SetEventInterface,
} from "src/app/interfaces/tagging.interface";
import { TaggingService } from "src/app/services/tagging.service";
import { CtrlRechargeService } from "src/app/services/ctrl-recharge/ctrl-recharge.service";
import { RechargeInterface } from "src/app/interfaces/ctrl-recharge.interface";
import { BranchIOService } from "src/app/services/branchIO/branch-io.service";
import { BranchNativeInterface } from "src/app/interfaces/brach-native.interface";
import { Subject, takeUntil } from "rxjs";
import { BottomSheetService } from "src/app/services/bottomSheet/bottom-sheet.service";
import { CardDialog } from "@tae/components";
import { DatePipe } from "@angular/common";
import { ScheduledRechageService } from "src/app/services/scheduled-recharge/scheduled-recharge.service";
import { ScheduledRechageInterface } from "src/app/interfaces/api/scheduled-rechage";
import { ErrorMessageInterface } from "src/app/interfaces/error-message.interface";
import { DialogErrorComponent } from "src/app/components/dialog-error/dialog-error.component";
import { CODE_ERRORS } from "@tae/constants";
import { PictureBasicCardInterface } from "src/app/interfaces/basic-card.interface";
/**
 *  Metodo para llamado a funcion nativa y realizar captura de pantalla
 */
declare function takeScreenshot(): any;
/**
 * Metodo para realizar llamado a funcion nativa
 * con la que se finaliza la  aplicacion
 */
declare function quitApp(): any;

/**
 * Metodo nativo para hacer solicitar validacion de token en autenticacio
 */
declare function requestToken(): any;

declare function getBranchData(): any;
/**
 * Funcion para registro de ecomerce
 * @param folio
 * @param compania
 * @param monto
 */
// declare function setPushEvent(folio, compania, monto, variante);

@Component({
    selector: "app-ticket",
    templateUrl: "./ticket.component.html",
    styleUrls: ["./ticket.component.scss"],
    standalone: false
})

/*Clase controladora para pantalla de confirmacion de compra de tiempo aire*/
export class TicketComponent implements OnInit, OnDestroy {
  /*Atributo para almacenar valores previamente ingresados por el usuario */
  data: DataStorage;
  /* Atributo para mostrar o ocultar boton de captura*/
  buttonEnableCapture = true;
  //Datos del diccionario de commons
  textTokens: any = {};

  public confirmRechargeSchedule: boolean = false;

  public isRechargeSchedule: boolean = false;

  public frecuency = "mensuales";

  public nextRechargeDate = '';

  private _BSS: any = null;

  public nickName = '';

  /**
	 * Subject that unsubscribes from the Observables.
	 *
	 * @private
	 * @memberof CapturaComponent
	 */
	private _destroyed$ = new Subject<boolean>();

  public get recharge(): RechargeInterface {
    return this.ctrlRecharge.recharge;
  }

  public get picture(): PictureBasicCardInterface {
    const { billerId } = this.recharge.biller;
    return this.ctrlRecharge.getPicture(billerId);
  }

  /* Instancia de servicios inyectados */
  private storageService = inject(StorageService);
  private mainService = inject(MainService);
  private router = inject(Router);
  private readonly goPayCommonms = inject(GoPayCommonsService);
  private taggingService = inject(TaggingService);
  private ctrlRecharge = inject(CtrlRechargeService);
  private bios = inject(BranchIOService);
  private readonly ngZone = inject(NgZone);
  private readonly _environment = inject(ENV_CONFIG);
  private readonly bss = inject(BottomSheetService);
  private _datePipe = inject(DatePipe);
  private srs = inject(ScheduledRechageService);

  /* Instancia de contructor y definicion de  proceso donde se encuentra  */
  constructor() {
    (window as any).angularComponentRef = {
      component: this,
      zone: this.ngZone,
      loadAngularFunction: (_command, _data) =>
        this.onBranch(_command, _data as BranchNativeInterface),
      componentToken: (succesTkn, tipoOTP, date, errorTkn) =>
        this.receiveTokenFromNative(succesTkn, tipoOTP, date, errorTkn),
    };

    this._readData();
  }
  /*Inicializaa el componente y ajusta la vista en el top */
  ngOnInit() {
    getBranchData();
    setTimeout(() => {
      window.scroll(0, 0);
      this.mainService.showSpinner(false);
    }, 3000);
    this.fetchJsonData();
    this.taggingPage();
  }

  private taggingPage(): void {
    const { biller, amount } = this.recharge;
    const pageView: PageViewInferface = {
      url: "recarga_celular/comprobante",
      canalBanco: "supermovil",
      titulo: "recarga_celular|comprobante",
      subsection1: "recarga_celular",
      userId: "",
      marca: biller?.name,
      monto: amount.toString(),
      entorno: this.storageService.get("ENV"),
      versionApp: "",
      event: "PageView",
    };
    if (this.isRechargeSchedule) {
      const dataBSS = this._BSS ? JSON.parse(this._BSS) : {};
      const frequencyValue = dataBSS?.arrayDetailsRecharges?.find((item: any) => item.id === "frecuency")?.value;
      pageView.periodicidad = frequencyValue ? frequencyValue.toLowerCase() : this.data.biller?.periodicity;
      pageView.proceso = 'recarga_automatica';
      if (this.confirmRechargeSchedule) {
        pageView.url = 'pago_automatico/recarga_celular/comprobante',
        pageView.titulo = 'pago_automatico|recarga_celular|comprobante'
      }
    }

    this.taggingService.setPageView(pageView);
  }

  private _confirmRechargeSchedule() {
    const $confirmDialog = new Subject<string>();
    const dataBSS = this._BSS ? JSON.parse(this._BSS) : {};
    const getDate = dataBSS?.arrayDetailsRecharges.find(item => item.id === "rechargeFirst")?.data;
    if (getDate) {
      this.nextRechargeDate = this._datePipe.transform(getDate, 'dd/MMM/yy');
    }
    this.bss.show(CardDialog, {
      ...dataBSS,
      confirmRechargeSchedule: true,
      $confirmDialog: $confirmDialog
    });

    $confirmDialog.pipe(takeUntil(this._destroyed$))
      .subscribe({
        next: () => {
          // this.confirmRechargeSchedule = true;
          this._sendRequest();
        },
        error: (error) => {
          console.error("Error in confirm dialog:", error);
        }
      });
  }

  /**
   * FUNCION QUE RECIBE EL TOKEN DESDE LA NATIVA
   * @param token
   * @param tipoOTP
   * @param date
   * @param message
   */
  receiveTokenFromNative(
    token: string,
    tipoOTP: string,
    date: string,
    message: string
  ) {
    this.mainService.showSpinner(true);
    const THIS = this;
    this.ngZone.run(() => {
      if (token && token !== null && token !== undefined) {
        THIS.storageService.set("token2fa", token);
        THIS.storageService.set("isTransmit", tipoOTP);
        THIS.sendScheduled();
      } else {
        THIS.mainService.showSpinner(false);
      }
    });
  }

  private sendScheduled(): void {
    const data = this.buildScheduledRecharge();
    this.srs.create(data).subscribe((_response) => {
      try {
        const { statusCode } = _response?.status;
        if (!_response?.data?.folio) {
          this.mainService.showSpinner(false);
          // Si statusCode es exitoso pero folio es null, el número ya está registrado
          const isDuplicateNumber = statusCode === 'SCF000';
          const errorData: ErrorMessageInterface = isDuplicateNumber
            ? {
                title: 'No pudimos completar tu solicitud',
                message: 'El número que ingresaste ya está asociado a una recarga programada, revisa el detalle en Domiciliación o intenta con otro número',
                code: 'GOTA05',
                status: 'GOTA05',
                pathImage: 'ta-disconnected',
                icon: 'plug'
              }
            : this.findError(statusCode);
          this.taggingService.setEvent({
            event: "payments",
            categoria: "error",
            accion: "pago_automatico/recarga_celular/confirmacion",
            etiqueta: isDuplicateNumber
              ? 'numero_duplicado_recarga_programada'
              : `${statusCode}_${errorData.message}`.toLowerCase().replace(/ /g, "_"),
            canalBanco: "supermovil",
            userID: "",
          });
          this.errorMessage({ ...errorData, skipTagging: true });
          return;
        }
        this.confirmRechargeSchedule = true;
        this.data.confirmRechargeSchedule = true;
        this.data.folio = _response.data.folio;
        this.data.isRechargeSchedule = true;
        const data = this.storageService.safeStringify(this.data);
        this.storageService.set('data', data);

        // No invalidar cache - las recargas programadas no afectan el historial de recargas normales
        // y el saldo no cambia hasta que se ejecute la recarga
        this._readData();
      } catch (error) {
        this.mainService.showSpinner(false);
        const errorData = CODE_ERRORS['STATUS_RESPONSE_CAT'];
        this.taggingService.setEvent({
          event: "payments",
          categoria: "error",
          accion: "pago_automatico/recarga_celular/confirmacion",
          etiqueta: `error_${errorData.message}`.toLowerCase().replace(/ /g, "_"),
          canalBanco: "supermovil",
          userID: "",
        });
        this.errorMessage({ ...errorData, skipTagging: true });
      }
    });
  }

  private findError(statusCode: string): ErrorMessageInterface {
    if (CODE_ERRORS.hasOwnProperty(statusCode)) {
      return { ...CODE_ERRORS[statusCode] };
    }
    const find = Object.keys(CODE_ERRORS).find((_key) => CODE_ERRORS[_key].code === statusCode);
    return CODE_ERRORS[find] || CODE_ERRORS['STATUS_RESPONSE_PAY'];
  }

  /**
     *
     * @param { ErrorMessageInterface }_settings
     */
    errorMessage(_settings: ErrorMessageInterface): void {
      this.mainService.showSpinner(false);
      const error: ErrorMessageInterface = {
        ..._settings,
        pathImage: _settings.pathImage || "ta-disconnected",
        icon: _settings.icon || "plug",
        buttonLabel:
          _settings.buttonLabel || this.textTokens.ERROR_MESSAGE_ACCEPT,
        closeLabel: _settings.closeLabel || this.textTokens.ERROR_MESSAGE_CLOSE,
      };
      const dataBSS = {
        _data: error,
        close: () => this.onCloseError(error),
        config: {
          closeLabel: error.closeLabel,
        },
      };
      this.bss.show(DialogErrorComponent, dataBSS);
    }

    public onCloseError(_error: ErrorMessageInterface): void {
      const { status } = _error;
      this.bss.hide();
      if (
        status &&
        (status === "STATUS_RESPONSE_CAT" ||
          status === "STATUS_RESPONSE_KE" ||
          status === "STATUS_RESPONSE_SSO" ||
          status === "STATUS_RESPONSE_CTAS" ||
          status === "STATUS_RESPONSE_GEO" ||
          status === "STATUS_RESPONSE_TYC" ||
          status === "STATUS_NO_ACC")
      ) {
        try {
          quitApp()
        } catch (error) {
          console.log(error, 'exit app captura');
        }
      }
    }

  private buildScheduledRecharge(): ScheduledRechageInterface {
    const { account, card } = this.recharge.accountSelected;
    const dataBSS = this._BSS ? JSON.parse(this._BSS) : {};
    const alias = dataBSS?.arrayDetailsRecharges?.find(item => item.id === "alias")?.value || '';
    const period = dataBSS?.arrayDetailsRecharges?.find(item => item.id === "frecuency")?.value || 'MENSUAL';
    this.nickName = alias;
    const rechargeFirst = dataBSS?.arrayDetailsRecharges?.find(item => item.id === "rechargeFirst")?.data || this.data.do;
    let token;
    const isTransmit = localStorage.getItem("isTransmit");
    token = isTransmit.toString() === 'true' ? "11111111" : this.storageService.get("token2fa");
    token = token?.substring(0, 8);
    return {
      data: {
        customer: {
          customerId: this.storageService.get('buc'),
          emailAddress: '',
        },
        account: {
          accountNumber: account.accountNumber,
        },
        card: {
          cardType: card.cardType,
          cardNumber: this.recharge.accountSelected.card.cardNumber,
        },
        scheduledPayment: {
          nickname: alias,
          amountDue: dataBSS?.arrayDetailsRecharges?.find(item => item.id === "amount")?.data,
          dueDate: this.formatDate(rechargeFirst),
          scheduledType: 'REC',
          reference: this.recharge.phone,
          idProducto: this.recharge.product,
          frequency: period,
        },
        biller: {
          name: this.recharge.biller.name,
          billerId: this.recharge.biller.billerId,
        },
      },
      token,
    }
  }

  private formatDate(date: string): string {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  private _sendRequest() {
    try {
      requestToken();
    } catch (error) {
      console.error("Error requesting token:", error);
    }
  }

  public openNewRecharge() {
    const event: SetEventInterface = {
      event: "payments",
      categoria: "recarga_celular",
      accion: "comprobante",
      etiqueta: "recargar_otro_numero",
      canalBanco: "supermovil",
      url: "recarga_celular/comprobante",
      userID: "",
    };
    if (this.confirmRechargeSchedule) {
      event.categoria = 'pago_automatico';
      event.url = 'pago_automatico/pago_de_servicios/comprobante';
    }
    // La recarga ya se agregó al historial en captura.component.ts cuando fue exitosa
    this.taggingService.setEvent(event);
    this.router.navigateByUrl("/history");
  }

  async onBranch(
    _command: string,
    _data: BranchNativeInterface
  ): Promise<void> {
    console.log(_command, _data);

    if (_command !== "BRANCH") {
      return;
    }
    const { biller, amount } = this.recharge;
    await this.bios.send(
      this.storageService.get("anonimized"),
      biller?.name,
      amount.toString(),
      _data
    );
  }

  //Obtener el diccionario de datos de commons
  fetchJsonData() {
    this.goPayCommonms.getTextTokens().subscribe((data: any) => {
      this.textTokens = data;
    });
  }

  /**
   * Se leen los datos desde el storage
   */
  private _readData(): void {
    this.data = JSON.parse(this.storageService.get("data"));
    const { account } = this.data.accountSelected;
    const { currency } = account.balance.amount;

    this.data = {
      ...this.data,
      cta: this.buildDetailAccount(),
      amo: parseInt(this.data.amount.toString())?.toFixed(2),
      currency: currency === "MXP" ? "MXN" : currency,
    };
    this.isRechargeSchedule = this.data?.isRechargeSchedule || false;
    if (this.data?.isRechargeSchedule) {
      this._BSS = this.data?.dataBSS;
      const dataBSS = this._BSS ? JSON.parse(this._BSS) : {};
      this.nickName = dataBSS?.arrayDetailsRecharges?.find(item => item.id === "alias")?.value || '';
      const getFrecuency = this.data.biller?.periodicity;
      if (getFrecuency) {
        this.frecuency = `${ dataBSS?.arrayDetailsRecharges?.find(item => item.id === "frecuency")?.value?.toLowerCase() }es`;
      }
      this.confirmRechargeSchedule = this.data?.confirmRechargeSchedule || false;
      if (!this.confirmRechargeSchedule){
        this._confirmRechargeSchedule();
        return;
      }
      this.mainService.showSpinner(false);
      this.taggingPage();
    } else {
      this.confirmRechargeSchedule = false;
    }
    // setPageView('/ticket','|ticket','Ticket','Thankyoupage',this.storageService.get("anonimized"), this.storageService.get("ENV_TAGGEO"), this.data.amo , this.data?.com?.name)
    // setPushEvent(
    //   this.data.folio,
    //   this.data.com?.name,
    //   this.data.amo,
    //   this.data.acc?.account?.product?.productName
    // );
    this._setAmoutRecharge();
  }

  private _setAmoutRecharge() {
    if (this.confirmRechargeSchedule) {
      const dataBSS = this._BSS ? JSON.parse(this._BSS) : {};
      this.data.amo = this.formatCurrency(dataBSS?.arrayDetailsRecharges?.find((item: any) => item.id === "amount")?.data);
      this.frecuency = `${ dataBSS?.arrayDetailsRecharges?.find((item: any) => item.id === "frecuency")?.value?.toLowerCase() }es`;
    }
  }

  public openRechargeSchedule(): void {
    const event:SetEventInterface = {
      event: "payments",
      categoria: "recarga_celular",
      accion: "comprobante",
      etiqueta: "pago_automatico",
      canalBanco: "supermovil",
      url: "recarga_celular/comprobante",
      userID: "",
    }
    this.taggingService.setEvent(event);
    this._confirmRechargeSchedule();
  }

  private formatCurrency(value: number | string) {
    const num = typeof value === 'string' ? parseFloat(value) : value;
    const truncated = Math.trunc(num * 100) / 100;
    return truncated.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  private buildDetailAccount(): string {
    const { card, account } = this.data.accountSelected;
    const { cardType, cardNumber } = card;
    const { accountNumber } = account;
    if (cardType === "TDC") {
      return `${cardType} ${cardNumber.slice(0, 4)}**${cardNumber.slice(-4)}`;
    }
    return `CTA ${accountNumber.slice(0, 2)}**${accountNumber.slice(-4)}`;
  }

  /**
   * Navega hacia el root principal
   */
  continue(): void {
    // setEvent('ticket','finalizar');
    let userId = this.storageService.get("anonimized");
    this.storageService.clearKey("data");
    this.storageService.clearKey("token2fa");
    localStorage.removeItem("isTransmit")
    if (this._environment.production) {
      this.router.navigate(["/captura"], { queryParams: { userId: userId } });
    } else {
      let token = this.storageService.get("buc");
      this.router.navigate(["/captura"], { queryParams: { token: token } });
    }
  }

  quit(): void {
    try {
      quitApp();
    } catch (error) {
      console.log(error, 'fallo salir de la app');
    }

  }
  /* Descraga de comprobante al havcer llamado a funcion nativanp*/
  screenshot(): void {
    const action: SetEventInterface = {
      event: "payments",
      categoria: "recarga_celular",
      accion: "comprobante",
      etiqueta: "compartir_comprobante",
      canalBanco: "supermovil",
      url: "recarga_celular/comprobante",
      userID: "",
    };
    if (this.confirmRechargeSchedule) {
      action.categoria = 'pago_automatico';
      action.url = 'pago_automatico/pago_de_servicios/comprobante'
    }
    this.taggingService.setEvent(action);
    window.scrollTo(0, 0);
    document.body.style.backgroundColor = "#FFF";
    // setEvent('ticket','obtener_imagen');
    this.buttonEnableCapture = false;
    setTimeout(() => {
      try {
        takeScreenshot();
      } catch (error) {
        console.log(error, 'screenshot');
      }

    }, 1000);
    setTimeout(() => {
      this.buttonEnableCapture = true;
      document.body.style.removeProperty("background-color");
    }, 2500);
  }

  ngOnDestroy(): void {
    this._destroyed$.next(true);
		this._destroyed$.complete();
  }
}
